import * as React from "react";
import styled, { css } from "styled-components";
import { Timestamp, Spinner } from "components/common";
import useMessage from "views/hooks/useMessage";
import Popover from "components/common/Popover";
import {
  isLogEvidence,
  removeIlluminateEventDefinitionPrefix,
  evidenceTypeLabel
} from "security-app/components/Investigations/Details/TimelineSegment/Utils";
import MessageSummary from "search/MessageSummary";
const HoverLabelContainer = styled.div(
  ({ positionX, positionY }) => css`
    position: absolute;
    left: ${positionX}px;
    top: ${positionY + 10}px;
  `
);
const StyledTimestamp = styled(Timestamp)(
  ({ theme }) => css`
    color: ${theme.colors.text.secondary};
  `
);
const Header = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
  margin-bottom: 5px;
`;
const HoverLabelFoundation = ({
  evidence,
  children = void 0,
  isLoading = false
}) => {
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Header, null, /* @__PURE__ */ React.createElement("b", null, evidenceTypeLabel(evidence.type)), /* @__PURE__ */ React.createElement(StyledTimestamp, { dateTime: evidence.timestamp })), children);
};
const EventHoverLabel = ({ evidence }) => /* @__PURE__ */ React.createElement(HoverLabelFoundation, { evidence }, removeIlluminateEventDefinitionPrefix(evidence.entity.message));
const MessageHoverLabel = ({ evidence }) => {
  const { data: message, isInitialLoading } = useMessage(evidence.entity.index, evidence.id);
  return /* @__PURE__ */ React.createElement(HoverLabelFoundation, { evidence, isLoading: isInitialLoading }, /* @__PURE__ */ React.createElement(MessageSummary, { messageFields: message == null ? void 0 : message.fields, renderMessageRow: () => message == null ? void 0 : message.fields.message }));
};
const TimelineHoverlabel = ({
  positionX,
  positionY,
  evidence
}) => /* @__PURE__ */ React.createElement(HoverLabelContainer, { positionX, positionY }, /* @__PURE__ */ React.createElement(Popover, { opened: true, width: 300, withArrow: true, withinPortal: true }, /* @__PURE__ */ React.createElement(Popover.Target, null, /* @__PURE__ */ React.createElement("div", { style: { width: "20px" } })), /* @__PURE__ */ React.createElement(Popover.Dropdown, { id: "edit-search-filter-dropdown" }, isLogEvidence(evidence) ? /* @__PURE__ */ React.createElement(MessageHoverLabel, { evidence }) : /* @__PURE__ */ React.createElement(EventHoverLabel, { evidence }))));
export default TimelineHoverlabel;
